export const GRUNDTEIGE_BASE_ROUTE = '/grundteige';
